import { useEffect, useRef, useState } from "react";
import { isMobile } from 'react-device-detect';


const About = ({ currRef, profileData }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.2 }
        );

        if (currRef.current) {
            observer.observe(currRef.current);
        }

        return () => observer.disconnect();
    }, []);



    return (
        <section id="about" ref={currRef} className={`${isMobile ? "min-h-screen" : ""} flex items-center justify-center py-20 px-4`}>
            <div className="max-w-6xl mx-auto w-full pt-6">
                <h2
                    className={`text-4xl md:text-5xl font-bold text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                        }`}
                >
                    About <span className="text-cyan-400">Me</span>
                </h2>

                <div className="h-10"></div>

                <div className="max-w-6xl mx-auto w-full grid md:grid-cols-2 gap-12 items-center">


                    <div
                        className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
                            }`}
                    >
                        <div className="relative flex justify-center md:justify-end w-auto mx-10">
                            <div className="bg-white shadow-lg h-48 w-48 md:h-80 md:w-80 rounded-3xl overflow-hidden">
                                <img
                                    src={profileData?.profile_icon}
                                    alt="Profile"
                                    className="h-full w-full object-cover"
                                />
                            </div>
                        </div>
                    </div>

                    <div
                        className={`transition-all duration-1000 delay-400 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
                            }`}
                    >
                        <div className="mx-5 md:w-1/2 text-center md:text-left">
                            <p
                                className="text-gray-300 leading-relaxed"
                                dangerouslySetInnerHTML={{
                                    __html: profileData?.bio.replace(/\n/g, "<br />"),
                                }}
                                />
                        </div>
                    </div>
                </div>


            </div>
        </section >
    );
};

export default About;
